import React from "react";
import "./Switch.style.scss";

import { Switch as AntdSwitch } from "antd";

export default function Switch(props) {
  return <AntdSwitch {...props} className="switchComponent" />;
}
